export const mapConstants = {
  MAP_REQUEST: 'MAP_REQUEST',
  MAP_SUCCESS: 'MAP_SUCCESS',
  MAP_FAILURE: 'MAP_FAILURE'
}
